/**
 * CMSD Version 1
 *
 * @group CMSD
 *
 * @beta
 */
export const CMSD_V1 = 1;
